import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section footer-logo-section">
          <div className="footer-logo-container">
            <img
              src="/logo.svg"
              alt="Erin Counselling Logo"
              className="footer-logo"
            />
            <p>Erin Robinson Counselling</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/" end>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about">About Me</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/approach">Approach</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
            <li>
              <Link to="/fees">Fees / Rates</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Address</h3>
          <div className="footer-info">
            <p>The Space Holistic Wellness Centre</p>
            <p>577 Rossouw Street</p>
            <p>Die Wilgers</p>
            <p>Pretoria, 0184</p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Contact Details</h3>
          <div className="footer-info">
            <p>+27 71 496 7512</p>
            <p>erinrobinsoncounselling@gmail.com </p>
            <div className="follow-us">
              <h3>Follow Me</h3>
              <div className="social-links">
                <a
                  href="https://www.instagram.com/erinrobinsoncounselling?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/erin-robinson-282733213/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Erin Robinson Counselling. All
          Rights Reserved | <Link to="/privacy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
